<template>
  <div id="settleAccounts" v-loading="isLoading">
    <div class="public-content">
      <div class="settleAccounts_top">
        <el-button
          class="minButton"
          size="small"
          v-for="item in buttonOptions"
          @click="handleClick(item)"
          :key="item.name"
          :disabled="item.icon"
        >{{item.name}}</el-button>
        <span class="vouchers">共录入凭证{{form.total?form.total:0}}张</span>
      </div>
      <div>
        <!-- 期末检查项 -->
        <transition name="mg-toggle">
          <div class="result" v-if="resultShow">
            <p class="result-title">赤字检查</p>
            <div class="result-list">
              <p v-for="item in checkData.codeList" :key="item.code" class="clearfix item_CZ">
                <span class="result-name" v-text="item.name"></span>
                <span class="result-text fr">
                  <span v-text="item.msg" :style = "{ color:item.isDeficit?'red':'#333' }"></span>
                  <i
                    :class="item.isDeficit?'el-icon-circle-close-outline':'el-icon-circle-check-outline'"
                  ></i>
                </span>
              </p>
            </div>
            <p class="result-title">固定资产净值</p>
            <div class="result-list">
              <p v-for="item in checkData.otherList" :key="item.code" class="clearfix item_CZ">
                <span class="result-name" v-text="item.name"></span>
                <span class="result-text fr">
                  <span v-text="item.msg" :style = "{ color:item.isDeficit?'red':'#333' }"></span>
                  <i
                    :class="item.isDeficit?'el-icon-circle-close-outline':'el-icon-circle-check-outline'"
                  ></i>
                </span>
              </p>
            </div>
            <p class="result-hidden" @click="resultShow = false">
              收起
              <i class="el-icon-arrow-up"></i>
            </p>
          </div>
        </transition>
        <!-- 模板 -->
        <div class="knots-form">
          <div class = "form-item" v-for = "(i,index) in templateList" :key = "index">
            <span class="knots-name bold">{{ i.name }}</span>
            <span v-if='i.list&&i.list.length'>
               <a
                href="javaScript:;"
                v-for="(item,indexs) in i.list"
                :key = "indexs"
                class='lookItem'
                v-text="item.word + '_' + item.number"
                @click="handleClickDialogShow(item)"
              ></a>
            </span>
            <span class='lookItem' v-else-if = 'i.state == 2'>
               <img src="../../../static/icon/preview.svg" alt="预览凭证" @click="handleClickDialogPreview(i)" title='预览凭证'>
            </span>
            <span class='lookItem' v-else-if = "i.state == 1">
               <img src="../../../static/icon/noVoucher.svg" alt="预览凭证" @click="handleClickDialogPreview(i)" title='预览凭证'>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 修改凭证  -->
    <edit-voucher
      :visible.sync="XG_voucherShow"
      :row="rows"
      @on-close-dialog="cancel"
      @on-success-submit="successEdit"
      :openButton_s="openButton_s"
      v-if="XG_voucherShow"
    ></edit-voucher>
    <!-- 结转 -->
    <CarryForward
      :isShow="isShow"
      :forwardType="forwardType"
      :displayData="displayData"
      @confirm="handleConfirm"
      @cancel="isShow = false"/>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import editVoucher from "@/components/table/editVoucher";
import CarryForward from './CarryForward'
export default {
  components: {
    editVoucher,CarryForward
  },
  data() {
    return {
      displayData:false,
      templateList:[], // 模板列表
      openButton_s: false,
      ifmbf: false, //民办非
      FJSQ_disabled: false,
      rows: "", // 点击数据
      XG_voucherShow: false, // 修改弹框
      isLoading: false,
      resultShow: false, // 期末检查是否显示
      isShow: false, // 结转弹出框
      forwardType: '', // 反结转还是结转
      buttonOptions: [],
      form: {},
      voucherForm: {
        voucherWordId: "", // 凭证字id
        deprVoucherWordId: "", // 计提凭证字id
        deprDate: "", // 计提日期
        date: "", // 损益日期
        subjectId: "", // 损益科目id
        deprSummary: "", // 计提摘要
        summary: "", // 损益摘要
        settleAccounts: true, // 是否选择了计提
        profit: true // 是否选择了损益
      },
      voucherWord: [], // 凭证字
      isFirstActive:false,
      checkData: {} // 期末检查数据
    };
  },
  created() {
    //this.getButton();
    this.checkIfPrivateNonProfit();
    this.getCarryForwardInfo();
    this.getVoucherWord();
    this.getSubject();
    this.getAccountPeriods();
  },
  activated() {

    if(this.getClickCache&&this.isFirstActive) {
      this.checkIfPrivateNonProfit();
      this.getCarryForwardInfo();
      this.getVoucherWord();
      this.getSubject();
      this.getAccountPeriods();
    }
    this.isFirstActive = true;
  },
  computed: {
    ...mapGetters(["accountInfoData"]),
    getClickCache() {
      return this.$store.state.loadstatus.isClickCache;
    },
    // 科目
    subjectData() {
      return this.$store.state.getSubjectId.SubjectList;
    },
    getAccountPeriod() {
      return this.$store.state.accountInfo.yearPeriods.startTimeStamp;
    },
    getAccountEndPeriod() {
      return this.$store.state.accountInfo.yearPeriods.endTimeStamp;
    },
    accountInfo() {
      return this.$store.state.accountInfo.accountInfoData.yearPeriodTimeStamp;
    },
  },
  methods: {
    //查询是否是否为民间非盈利
    checkIfPrivateNonProfit() {
      const _ = this;
      _.isLoading = true;
      _.$http
        .post("createAccountSet/isPrivateNonProfit", {})
        .then(res => {
          _.isLoading = false;
          if (res && res.data.code == "1") {
            _.ifmbf = res.data.data;
            if (res.data.data) {
              _.voucherForm.summary = "民间非盈利";
            }
          }
        })
        .catch(e => {
          _.isLoading = false;
        });
    },
    // 获取会计期间/初始化数据
    async getAccountPeriods() {
      let res = await this.$store.dispatch("getAllYearPeriodsData");
      this.getButton();
    },
    // accountInfos(){
    //  if(!this.accountInfo) {
    //    this.$store.dispatch('getAccountInfo')
    //  }
    // },
    // 关闭弹框
    cancel(val) {
      this.XG_voucherShow = val;
      this.openButton_s = false;
    },
    successEdit(val) {
      //修改成功后的回调
      if (val) {
        this.reflashPage();
      }
    },
    // 预览凭证
    handleClickDialogPreview(item) {
      let _row = item.voucherChiefVo;
      _row.preVoucherAddendumList = item.voucherAddendumVoList;
      _row.date = this.$util.formatDate.format(_row.date,'yyyy-MM-dd');
      _row.isGenerate = true;
      console.log(_row);

      this.rows = _row;
      this.XG_voucherShow = true;
      this.openButton_s = true;
    },
    // 查看凭证
    handleClickDialogShow(row) {
      this.rows = row;
      this.XG_voucherShow = true;
      this.openButton_s = true;
    },
    // 查询所有科目
    getSubject() {
      if (!this.subjectData) {
        this.$store.dispatch("getSubject");
      }
    },
    // 获取结转信息
    getCarryForwardInfo() {
      this.voucherForm = Object.assign(this.voucherForm, {
        deprSummary: "计提折旧费用",
        summary: this.ifmbf ? "民间非盈利" : "结转本期损益",
        profit: true
      });
      this.isLoading = true;
      try {
        this.templateList = [];
        this.$http.post("/fettleAccounts/newGetCarryForward", {}).then(res => {
          this.isLoading = false;
          if (res.data.code == '1') {
            this.templateList = res.data.data.template;
            this.form = Object.assign({}, res.data.data, {
              date: this.$util.formatDate.format(
                res.data.data.date,
                "yyyy-MM-dd"
              )
            });
            this.displayData = res.data.data.displayData
            this.voucherForm = Object.assign(this.voucherForm, {
              deprDate: this.form.date,
              date: this.form.date,
              subjectId: this.form.profitId
            });

            this.voucherForm.settleAccounts = this.form.isDepreciation == 1 ? true : false;
          }
        });
      } catch (e) {
        this.isLoading = false;
      }
    },
    // 获取所有凭证字
    getVoucherWord() {
      try {
        this.$http.post("voucherWord/list", {}).then(res => {
          if (res) {
            this.voucherWord = res.data.data;
            this.voucherForm = Object.assign(this.voucherForm, {
              voucherWordId: this.voucherWord.length && this.voucherWord[0].id,
              deprVoucherWordId:
                this.voucherWord.length && this.voucherWord[0].id
            });
          }
        });
      } catch (e) {}
    },
    // 按钮点击事件
    handleClick(item) {
      const prevent = this.$getSessionStorage("superPreventOperation");
      if (prevent && item.function != "finalExamination") {
        this.$store.commit("SUPERPREVENTFUNCTION", true);
        return;
      }
      switch (item.function) {
        case "generateCredentials":
          this.getJZSY();
          break;
        case "finalExamination":
          this.getQMJC();
          break;
        case "double":
          this.beforeForWard("2");
          break;
        case "double1":
          this.beforeForWard("1");
          break;
        case "BB_Relationship":
          this.getCXJSBBGX();
          break;
        case "SJ_Relationship":
          this.getCXJSDQSJ();
          break;
      }
      if (item.function != "finalExamination") {
        this.resultShow = false;
      }
    },

    // 生成结转损益
    getJZSY() {
      try {
        this.isLoading = true;
        this.$http
          .post("fettleAccounts/getProfitAndLoss", this.voucherForm)
          .then(res => {
            this.isLoading = false;
            if (res && res.data.code == 1) {
              this.getCarryForwardInfo();
              this.$message.success(res.data.msg);
            }
          });
      } catch (e) {
        this.isLoading = false;
      }
    },
    // 期末检查
    getQMJC() {
      let params = {
        yearPeriods: this.accountInfoData.nowYearPeriod
      };
      try {
        this.isLoading = true;
        this.$http.post("fettleAccounts/checkedIsDeficit", params).then(res => {
          console.log(res);
          this.isLoading = false;
          if (res) {
            this.checkData = res.data.data;
            this.resultShow = true;
          }
        });
      } catch (e) {
        this.isLoading = false;
      }
    },
    // 刷新页面
    reflashPage() {
      let NewPage = "_empty" + "?time=" + new Date().getTime() / 500;
      this.$router.push(NewPage);
      this.$router.go(-1);
    },
    // 结转前先打开弹框
    beforeForWard(val) {
      this.forwardType = val
      // 结转 结转时间的最大日期 == 期初时间，不需要打开弹框，传期初时间
      if (val == 1 && this.accountInfo == this.getAccountEndPeriod&&!this.displayData) {
        const params = {
          type: val,
          yearPeriods: this.$util.formatDate.format(this.accountInfo, 'yyyyMM')
        };
        this.CarryForward(params)
        return
      }
      this.isShow = true
    },
    // 结转弹出框确认事件
    handleConfirm(date,list) {
      this.isShow = false
      const params = {
        type: this.forwardType,
        yearPeriods: this.$util.formatDate.format(date , 'yyyyMM')
      };
        params.list = list.filter(e=>{
          if(e.other==false&&e.invoice==false&&e.bankReceipt==false&&e.statement==false){
            e.remarks=''
          }
          return e
        })
      this.CarryForward(params)
    },
    // 反结到上/下期  2:反结转  1:结转
    CarryForward(params) {
      try {
        this.isLoading = true;
          this.$http.post('fettleAccounts/carryDownOrForwardV2',params).then(res=>{
            if (res && res.data.code == 1) {
                this.$message.success("结转成功！");
            }
             this.getCarryForwardInfo();
             this.$store.dispatch("getAccountInfo");
             this.$store.dispatch("getAllYearPeriodsData");
             this.reflashPage();
            this.isLoading = false;
          })
      } catch (e) {
        this.isLoading = false;
      }
    },
    // 重新计算报表关系
    getCXJSBBGX() {
      try {
        this.isLoading = true;
        this.$http.post("subsidiaryLedger/anewReportRelation",{}).then(res => {
          this.isLoading = false;
          if (res && res.data.code == 1) {
            this.$message.success("重新计算报表关系成功!");
          }
        });
      } catch (e) {
        this.isLoading = false;
      }
    },
    // 重新计算当前数据
    getCXJSDQSJ() {
      try {
        this.isLoading = true;
        this.$http.post("subsidiaryLedger/reCalculation",{}).then(res => {
          this.isLoading = false;
          if (res && res.data.code == 1) {
            this.$message.success("重新计算当前数据成功!");
          }
        });
      } catch (error) {
        this.isLoading = false;
      }
    },
    // 获取按钮权限
    getButton() {
      let params = {
        permissions:
          "ac:settle:ProfitAndLoss,ac:settle:checked,ac:settle:carryDownOrForward,ac:settle:recalculation,ac:settle:repair,ac:settle:reporting_relationship"
      };
      try {
        this.$http.post("sys/menu/findPermissionMenu", params).then(res => {
          if (res.data.data.length) {
            let copy = {},
              Index = "";
            res.data.data.map((i, index) => {
              i.icon = false;
              if (i.function == "double") {
                copy = { ...i };
                copy.name = "结转到下期";
                copy.function = "double1";
                Index = index;
              }
              return i;
            });
            let start = res.data.data.slice(0, Index + 1);
            let end = res.data.data.slice(Index + 1);
            this.buttonOptions = start.concat(copy).concat(end);
            if (this.getAccountPeriod === this.accountInfo) {
              this.buttonOptions.forEach(i => {
                if (i.function == "double") {
                  console.log('已禁用反结按钮，原因：getAccountPeriod-' + this.getAccountPeriod + "对比accountInfo-" + this.accountInfo )
                  i.icon = true;
                }
              });
            } else if (this.getAccountPeriod < this.accountInfo) {
              this.buttonOptions.forEach(i => {
                if (i.function == "double") {
                  console.log('已开放反结按钮，原因：getAccountPeriod-' + this.getAccountPeriod + "对比accountInfo-" + this.accountInfo )
                  i.icon = false;
                }
              });
            } else {
              this.buttonOptions.forEach(i => {
                if (i.function == "double") {
                  console.log('已禁用反结按钮，原因：getAccountPeriod-' + this.getAccountPeriod + "对比accountInfo-" + this.accountInfo )
                  i.icon = true;
                }
              });
            }
          }
        });
      } catch (e) {}
    }
  },
  mounted() {}
};
</script>
<style lang='less' scoped>
#settleAccounts {
  position: relative;
  .settleAccounts_top {
    padding-bottom: 20px;
    border-bottom: 1px solid #ddd;
    .vouchers {
      position: absolute;
      right: 0;
      height: 28px;
      line-height: 28px;
      padding: 0 15px;
      border-radius: 14px 0 0 14px;
      font-size: 14px;
      color: #ffffff;
      background: #ec681d;
    }
  }
  .knots-form {
    padding: 20px 46px 0 0;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    flex-wrap: wrap;
  }
  .form-item {
    border:1px solid #eee;
    padding:30px;
    display: flex;
    border-radius: 4px;
    align-items: center;
    margin-right: 30px;
    margin-bottom: 20px;
    width: 200px;
    box-sizing: border-box;
    .lookItem {
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .knots-name {
    display: inline-block;
    color: #666;
    text-align: right;
    box-sizing: border-box;
  }
  .bold {
    font-weight: bold;
    color: #333;
  }
  .el-checkbox {
    margin-right: 0;
  }
  .result {
    padding: 20px 0px;
    .result-title {
      font-weight: bold;
    }
    .result-list {
      font-size: 14px;
      p {
        padding: 15px 46px;
        padding-right: 100px;
        border-radius: 5px;
        &::before {
          content: "";
          display: inline-block;
          border-radius: 4px;
          border: 4px solid #8b572a;
          position: relative;
          top: -2px;
        }
        &:hover {
          background: linear-gradient(to right, #ddd, #fff);
        }
        .result-name {
          color: #333;
          display: inline-block;
          margin-left: 20px;
        }
        .result-text {
          color: #666;
          i {
            margin-left: 20px;
            font-size: 20px;
            &.el-icon-circle-check-outline {
              color: #269d7b;
            }
            &.el-icon-circle-close-outline {
              color: #ec681d;
            }
          }
        }
      }
    }
    .result-hidden {
      text-align: center;
      cursor: pointer;
      color: #269d7b;
      i {
        margin: 0 6px;
      }
    }
  }
}
.mg-toggle-enter-active,
.mg-toggle-leave-active {
  transition: all 0.2s;
  transform-origin: 0 0;
}
.mg-toggle-enter,
.mg-toggle-leave-to {
  transform: scaleY(0);
}
.mg-toggle-enter-to,
.mg-toggle-leave {
  transform: scaleY(1);
}
</style>



// WEBPACK FOOTER //
// src/pages/settleAccounts/settleAccounts.vue